const normalizeString = (value) =>
  typeof value === 'string' ? value.trim() : '';

export const getVariantSpecEntries = (specs) => {
  if (!specs || typeof specs !== 'object') {
    return [];
  }

  const entries = Array.isArray(specs)
    ? specs.map((spec) => [spec?.key, spec?.value])
    : Object.entries(specs);

  return entries
    .map(([key, value]) => ({
      key: normalizeString(key),
      value: normalizeString(value),
    }))
    .filter((entry) => entry.key && entry.value);
};

export const formatVariantSpecLabel = (entry) => {
  if (!entry?.key || !entry?.value) {
    return '';
  }

  return `${entry.key}: ${entry.value}`;
};

export default function VariantSpecsPills({ specs, maxVisible = 2 }) {
  const entries = getVariantSpecEntries(specs);

  if (entries.length === 0) {
    return <span className="detail-placeholder">-</span>;
  }

  const visibleEntries = entries.slice(0, maxVisible);
  const hiddenCount = Math.max(entries.length - visibleEntries.length, 0);
  const fullLabel = entries.map(formatVariantSpecLabel).filter(Boolean).join(', ');

  return (
    <div className="variant-spec-pills" title={fullLabel}>
      {visibleEntries.map((entry) => (
        <span
          key={`${entry.key}-${entry.value}`}
          className="variant-spec-pill"
        >
          {formatVariantSpecLabel(entry)}
        </span>
      ))}
      {hiddenCount > 0 ? (
        <span className="variant-spec-pill variant-spec-pill--more">
          +{hiddenCount} more
        </span>
      ) : null}
    </div>
  );
}
